function t() {
  var phrase = "password1"
  var textBoxValue = document.getElementById("password").value;
  if (textBoxValue == phrase) {
    const template1 = document.querySelector('#order_button_template');
    const clone1 = template1.content.cloneNode(true);
    const parentElement1 = document.querySelector('#x');
    parentElement1.appendChild(clone1);

    const template2 = document.querySelector('#quantity_selector_template');
    const clone2 = template2.content.cloneNode(true);
    const parentElement2 = document.querySelector('#y');
    parentElement2.appendChild(clone2);

    const template3 = document.querySelector('#price_template');
    const clone3 = template3.content.cloneNode(true);
    const parentElement3 = document.querySelector('#price-temp');
    parentElement3.appendChild(clone3);
    
    
    const div = document.querySelector('#password_area');
    div.remove();
    
  } else {
// Alert message that is shown when incorrect password is input
    alert("Incorrect :(");
  }
}